
  import { Options, Vue } from 'vue-class-component';
  import HelloWorld from '../../components/HelloWorld.vue';
  import {DataUtil} from '@/util/DataUtil';
  import {agreementConfig} from '@/config/template';
  import {userAgreementConfig} from "@/config/template_new_user_agreeement";

  @Options({
    components: {
      HelloWorld,
    }
  })
  export default class App extends Vue {
      private temp: string = userAgreementConfig.template_new_protocol_20220427;

    private config: TemplateInterface = {
      // productName: '阳光家园',
      // companyFullName: '海南高宇网络技术有限公司',
      // companyShortName: '海南高宇',

        productName: '飞升之路',
        companyFullName: '海南无忌网络技术有限公司',
        companyShortName: '海南无忌',
        officialWebsite: 'https://www.hainanwuji.com/',
        mail:"2581786904@qq.com",
        cashConfig:`<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">500、800、1000、2000元提现需要依次满足四个阶段的条件，方可进行提现，各条件如下：(1)500元提现：第一阶段条件是余额满足500元，第二阶段条件是升级到105级，第三阶段条件是累计登录5天、每天看5个视频，第四阶段条件是集齐金木水火土五元素。（2)800元提现：第一阶段条件是余额满足800元，第二阶段条件是升级到115级，第三阶段条件是累计登录10天、每天看5个视频，第四阶段条件是集齐金木水火土五元素。(3)1000元提现：第一阶段条件是余额满足1000元，第二阶段条件是升级到135级，第三阶段条件是累计登录15天、每天看5个视频，第四阶段条件是集齐金木水火土五元素。(4)2000元提现：第一阶段条件是余额满足2000元，第二阶段条件是升级到155级，第三阶段条件是累计登录20天、每天看5个视频，第四阶段条件是集齐金木水火土五元素</span>
                      </p>`

    };

    mounted(){
      this.temp = DataUtil.replaceConfig(this.temp, this.config);
    }
  }
